import { baseApi } from '@/shared/api/baseApi';
import { cacheBaseKeys } from '@/shared/api/cacheTags';
import type { Language } from '@/shared/api/types';

const languageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLanguagesList: builder.query<Language[], void>({
      query: () => ({
        url: '/user/get-language/',
        method: 'GET',
      }),
      providesTags: [cacheBaseKeys.settingsLanguages],
    }),
  }),
});

export const { useGetLanguagesListQuery } = languageApi;
